// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2852":"css/admin-app.7027","3251":"css/app.7027"}[chunkId] + ".css";
};